import { useCatalogQueryStore } from 'features/catalog/yogiql-store'
import {
  useSnapshotHistory,
  type UseSnapshotHistoryReturn,
} from 'hooks/use-snapshot-history'

/** Container.tsx's undo/redo under `enhanced_dialect`: the same snapshot
 *  history, over the query store's panel and ghost stash. */
export function useCatalogYogiQLHistory(
  enabled: boolean,
): UseSnapshotHistoryReturn {
  const panels = useCatalogQueryStore((state) => state.panels)
  const ghosts = useCatalogQueryStore((state) => state.ghosts)
  const restore = useCatalogQueryStore((state) => state.restore)
  return useSnapshotHistory({
    key: { panels, ghosts },
    snapshot: () => {
      const { activePanelId, shownSearch } = useCatalogQueryStore.getState()
      return { panels, activePanelId, ghosts, shownSearch }
    },
    restore,
    enabled,
  })
}
